import { render, staticRenderFns } from "./PostcardBar.vue?vue&type=template&id=0dc5dd84&"
import script from "./PostcardBar.vue?vue&type=script&lang=js&"
export * from "./PostcardBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports